module.exports = __webpack_public_path__ + "static/media/Axial.2112901c.ogg";